import { TKey } from "@/app/translations/TKey";

export enum HowItWorksMockKind {
  CAPTURE = "CAPTURE",
  CUSTOMER_FILE = "CUSTOMER_FILE",
  PERSONA = "PERSONA",
  ASSISTANT = "ASSISTANT",
  CONNECTORS = "CONNECTORS",
}

export type HowItWorksBlock = {
  mock: HowItWorksMockKind;
  labelKey: TKey;
  titleKey: TKey;
  bulletKeys: TKey[];
};
